<template>
  <div>
    
    <div class="container full-height-login">
        <div class="pandora-title">
             <div class="row pt-5 mt-5 d-flex align-items-center">
                <div class="d-none d-lg-block col-md-6 text-right pr-5">
                  <img src="../assets/images/logo.png" />
                </div>
                <div class="d-lg-none d-xl-none d-block col-md-6">
                  <img src="../assets/images/logo.png" />
                </div>
                <div class="d-none d-lg-flex col-md-6 text-left border-left-div  pl-5">
                  <img src="../assets/images/logo_myiptv.png" class="img-fluid" >
                  <span class="d-flex align-items-center text-white size-58" > IPTV</span>
                </div>
                <div class="d-lg-none d-xl-none d-block text-center col-md-6">
                  <img src="../assets/images/logo_myiptv.png" class="img-fluid" >
                  <br><span class="align-items-center text-white size-58" > IPTV</span>
                </div>
              </div>
              <div v-if=" click_on_watch == false " class="row d-flex justify-content-center pt-4">
                <a v-on:click="updateWatch($event)">
                  <div class="circle-text">WATCH!</div>
                </a>                        
              </div>                            
              <div v-if=" user.isLoading == true " class="row d-flex justify-content-center">
                  <b-alert show>
                    CARICAMENTO IN CORSO!
                  </b-alert>             
              </div>
              <div v-if=" user.errorMessage != '' " class="row d-flex justify-content-center">
                  <div>
                    <b-alert variant="danger" show dismissible>
                      <strong>{{user.errorMessage}}</strong>
                    </b-alert>
                  </div>              
              </div>
              <div class="p-5"  v-if="click_on_watch == true">
                  <div class="d-none d-lg-flex justify-content-center">      
                    <form id="app" class="w-50" @submit="checkForm" method="post">                       
                      <div class="form-group">
                          <label class="text-white" for="username"><h4> Username </h4></label><br>
                          <input id="username" class="form-control" v-model="username" type="text" name="username" required autocomplete="off">
                      </div>
                      <div class="form-group">
                          <label class="text-white" for="password"><h4>Password</h4></label><br>
                          <input type="password" id="password" class="form-control" v-model="password" name="password" required>
                      </div>      
                      <div class="form-group">
                          <input class="btn btn-lg btn-iptv" v-html=" user.isLoading == true ? 'disabled' : '' " type="submit" value="Login">
                      </div>                
                    </form>
                  </div>
                  <div class="d-lg-none d-md-flex justify-content-center">      
                    <form id="app" class="w-100" @submit="checkForm" method="post"> 
                      <div class="form-group">
                          <label class="text-white" for="username"><h4> Username </h4></label><br>
                          <input id="username" class="form-control" v-model="username" type="text" name="username" required autocomplete="off">
                      </div>
                      <div class="form-group">
                          <label class="text-white" for="password"><h4>Password</h4></label><br>
                          <input type="password" id="password" class="form-control" v-model="password" name="password" required>
                      </div>
                      <div class="form-group">
                          <input class="btn btn-lg btn-iptv" v-html=" user.isLoading == true ? 'disabled' : '' " type="submit" value="Login">
                      </div>
                    </form>
                  </div>
              </div>
              <div class="p-5" >
                  
                  <a href="https://convergenze.it/it/cookies-policy" class="cookie-subtitle" target="_blank">Cookie policy</a> 
                  |
                  <a href="https://convergenze.it/it/privacy-policy" class="cookie-subtitle" target="_blank">Privacy policy</a>
              </div>
        </div>
    </div>
    <!-- <div class="container full-height">
     
      
    </div> -->

    
  </div>  
</template>

<script>
// @ is an alias to /src

import { mapActions, mapState } from 'vuex'

export default {
  name: 'login',
  components: {
    
  },
  computed: {   
    ...mapState({
        user: state => state.User
    }), 
  },
  data: function() {
      return {
          errors: [],
          username: "",
          password: "",
          click_on_watch: false
      }
  },
  methods: { 
      ...mapActions('User', [
        'login', 'loadTvTerritorio'
        ]),   
      checkForm: function(e) {
          //console.log("checkForm", {username: this.username, password: this.password});
          if(this.username.length > 0 && this.password.length > 0)
          {
            this.login([{username: this.username, password: this.password},this.reloadTer]);
              
          }
            
        e.preventDefault();
      },

      reloadTer(isLogged) {
        //console.log('RELOAD TER');
        if(isLogged){
          this.loadTvTerritorio();
        }
      },

      updateWatch(){
        this.click_on_watch = true;        
      }
  }
}
</script>

<style scoped lang="scss">

.size-58 {
  //font-size: 58px;
  font-size: 58px;
}
</style>